import { render, staticRenderFns } from "./ItemTeam.vue?vue&type=template&id=f2350d8c&scoped=true&"
import script from "./ItemTeam.vue?vue&type=script&lang=js&"
export * from "./ItemTeam.vue?vue&type=script&lang=js&"
import style0 from "./ItemTeam.vue?vue&type=style&index=0&id=f2350d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2350d8c",
  null
  
)

export default component.exports